import { render, staticRenderFns } from "./wl-drawer-search.vue?vue&type=template&id=168c9d7a&scoped=true&lang=pug"
import script from "./wl-drawer-search.js?vue&type=script&lang=js&external"
export * from "./wl-drawer-search.js?vue&type=script&lang=js&external"
import style0 from "./wl-drawer-search.styl?vue&type=style&index=0&id=168c9d7a&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168c9d7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('168c9d7a')) {
      api.createRecord('168c9d7a', component.options)
    } else {
      api.reload('168c9d7a', component.options)
    }
    module.hot.accept("./wl-drawer-search.vue?vue&type=template&id=168c9d7a&scoped=true&lang=pug", function () {
      api.rerender('168c9d7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wl-component-gallery/wl-drawer-search/wl-drawer-search.vue"
export default component.exports